export default "__VITE_ASSET__CaOYZ$qI__"